import { useState } from "react";
import BotonMapaProceso from "./BotonMapaProceso";
import { reconstruirCadena, buscarSugerencias } from './Trazabilidad';
const estadoColors = { aceptado:"#22c55e", disponible:"#22c55e", consumido:"#808085", pendiente:"#f59e0b", en_proceso:"#3b82f6", entregado:"#808085", aprobado:"#22c55e", rechazado:"#e63946", devuelto:"#e63946", cuarentena:"#f59e0b", abierta:"#e63946", cerrada:"#22c55e" };
const colorTipo = { INGRESO:"#2A7FFF", PALLET:"#7B5BF2", OT:"#1C3FAA", NC:"#e63946", AC:"#f59e0b" };
export default function Trazabilidad({ onVolver, oscuro, usuario }) {
  const [busqueda, setBusqueda]       = useState("");
  const [cadena, setCadena]           = useState([]);
  const [buscado, setBuscado]         = useState("");
  const [sugerencias, setSugerencias] = useState([]);
  const [sinResultados, setSinResultados] = useState(false);
  const bg     = oscuro ? "#09184D" : "#F0EEFF";
  const cardBg = oscuro ? "#0d2160" : "white";
  const texto  = oscuro ? "#EDF2FA" : "#2F3E2E";
  const borde  = oscuro ? "#1e3a8a" : "#eee";
  const navBg  = oscuro ? "#060f30" : "#09184D";
  const sub    = oscuro ? "#9aabd4" : "#808085";
  const buscar = (cod) => {
    const codigo = (cod || busqueda).trim();
    if (!codigo) return;
    const resultado = reconstruirCadena(codigo);
    setCadena(resultado);
    setBuscado(codigo);
    setSugerencias([]);
    setSinResultados(resultado.length === 0);
  };
  const onInputChange = (val) => {
    setBusqueda(val);
    setSugerencias(val.length >= 3 ? buscarSugerencias(val) : []);
    setSinResultados(false);
  };
  return (
    <div style={{ minHeight:"100vh", background:bg, fontFamily:"sans-serif" }}>
      <div style={{ background:navBg, padding:"1rem 1.5rem", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:100 }}>
        <div style={{ display:"flex", alignItems:"center", gap:"12px" }}>
          <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Menú</button>
          <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>🔗 Trazabilidad</span>
        </div>
        <span style={{ color:"rgba(255,255,255,0.5)", fontSize:"11px", fontFamily:"monospace" }}>End-to-end · MP → Cliente</span>
        {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="trazabilidad" oscuro={oscuro} />}
      </div>
      <div style={{ padding:"1.5rem", maxWidth:"760px", margin:"0 auto" }}>
        {/* BUSCADOR */}
        <div style={{ background:cardBg, borderRadius:"16px", padding:"1.5rem", border:`1px solid ${borde}`, marginBottom:"1.5rem", position:"relative" }}>
          <h2 style={{ fontSize:"15px", fontWeight:"700", color:texto, marginBottom:"4px" }}>Rastrear código</h2>
          <p style={{ fontSize:"12px", color:sub, marginBottom:"14px" }}>Ingresá cualquier código: IM-2026-001 · PAL-2026-0001 · OP-2026-0001 · NCI-2026-001</p>
          <div style={{ display:"flex", gap:"8px" }}>
            <input value={busqueda} onChange={e=>onInputChange(e.target.value)} onKeyDown={e=>e.key==="Enter"&&buscar()}
              placeholder="Ej: OP-2026-0001"
              style={{ flex:1, padding:"10px 14px", borderRadius:"10px", border:`1.5px solid ${borde}`, fontSize:"14px", background:bg, color:texto, fontFamily:"monospace", outline:"none" }}/>
            <button onClick={()=>buscar()} style={{ padding:"10px 20px", background:"#1C3FAA", color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontWeight:"700", fontSize:"14px" }}>Buscar</button>
          </div>
          {sugerencias.length > 0 && (
            <div style={{ position:"absolute", left:"1.5rem", right:"1.5rem", top:"calc(100% - 10px)", background:cardBg, border:`1px solid ${borde}`, borderRadius:"10px", boxShadow:"0 8px 24px rgba(0,0,0,0.12)", zIndex:50, overflow:"hidden" }}>
              {sugerencias.map(s=>(
                <div key={s.codigo} onClick={()=>{ setBusqueda(s.codigo); buscar(s.codigo); }}
                  style={{ padding:"10px 14px", cursor:"pointer", borderBottom:`0.5px solid ${borde}`, display:"flex", gap:"10px", alignItems:"center" }}
                  onMouseEnter={e=>e.currentTarget.style.background=oscuro?"#1e3a8a":"#F0EEFF"}
                  onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                  <span style={{ fontFamily:"monospace", fontWeight:"700", color:colorTipo[s.tipo]||"#7B5BF2", fontSize:"13px", minWidth:"130px" }}>{s.codigo}</span>
                  <span style={{ fontSize:"11px", color:sub, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{s.desc}</span>
                  <span style={{ marginLeft:"auto", fontSize:"10px", background:`${colorTipo[s.tipo]||"#7B5BF2"}22`, color:colorTipo[s.tipo]||"#7B5BF2", padding:"2px 7px", borderRadius:"5px", fontWeight:"700", flexShrink:0 }}>{s.tipo}</span>
                </div>
              ))}
            </div>
          )}
        </div>
        {/* SIN RESULTADOS */}
        {sinResultados && (
          <div style={{ textAlign:"center", padding:"3rem", background:cardBg, borderRadius:"16px", border:`1px solid ${borde}` }}>
            <p style={{ fontSize:"36px" }}>🔍</p>
            <p style={{ fontSize:"15px", fontWeight:"600", color:texto }}>Sin resultados para "{buscado}"</p>
            <p style={{ fontSize:"13px", color:sub }}>Verificá el código o buscá por IM, PAL, OP o NCI</p>
          </div>
        )}
        {/* TIMELINE */}
        {cadena.length > 0 && (
          <>
            <div style={{ background:cardBg, borderRadius:"12px", padding:"1rem 1.5rem", border:`1px solid #1C3FAA40`, marginBottom:"1.5rem", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <div>
                <p style={{ fontSize:"12px", color:sub, margin:"0 0 2px" }}>Cadena de trazabilidad para</p>
                <p style={{ fontSize:"16px", fontWeight:"800", color:"#1C3FAA", margin:0, fontFamily:"monospace" }}>{buscado.toUpperCase()}</p>
              </div>
              <span style={{ fontSize:"12px", background:"#1C3FAA15", color:"#1C3FAA", padding:"4px 12px", borderRadius:"20px", fontWeight:"700" }}>
                {cadena.length} eslabón{cadena.length!==1?"es":""}
              </span>
            </div>
            <div style={{ position:"relative" }}>
              <div style={{ position:"absolute", left:"23px", top:"24px", bottom:"24px", width:"2px", background:"linear-gradient(to bottom,#2A7FFF,#7B5BF2,#1C3FAA,#e63946,#f59e0b)", opacity:0.3, zIndex:0 }}/>
              {cadena.map((e, idx)=>(
                <div key={e.codigo+idx} style={{ display:"flex", gap:"16px", marginBottom:"16px", position:"relative", zIndex:1 }}>
                  <div style={{ width:"48px", height:"48px", borderRadius:"50%", background:e.esDestacado?e.color:`${e.color}22`, border:`2px solid ${e.color}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"18px", flexShrink:0, boxShadow:e.esDestacado?`0 0 0 4px ${e.color}22`:"none" }}>
                    {e.icono}
                  </div>
                  <div style={{ flex:1, background:e.esDestacado?`${e.color}08`:cardBg, border:`1.5px solid ${e.esDestacado?e.color:borde}`, borderRadius:"12px", padding:"14px 16px" }}>
                    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:"8px" }}>
                      <div>
                        <span style={{ fontSize:"10px", fontWeight:"700", color:e.color, textTransform:"uppercase", letterSpacing:".08em" }}>{e.titulo}</span>
                        <div style={{ fontSize:"15px", fontWeight:"800", color:e.color, fontFamily:"monospace", marginTop:"2px" }}>{e.codigo}</div>
                      </div>
                      <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", gap:"4px" }}>
                        {e.estado && <span style={{ fontSize:"10px", fontWeight:"700", color:estadoColors[e.estado]||sub, background:`${estadoColors[e.estado]||"#808085"}18`, padding:"3px 8px", borderRadius:"8px" }}>{e.estado.replace(/_/g," ")}</span>}
                        <span style={{ fontSize:"10px", color:sub }}>{e.fecha ? new Date(e.fecha).toLocaleDateString("es-AR",{day:"2-digit",month:"2-digit",year:"numeric"}) : "—"}</span>
                      </div>
                    </div>
                    <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))", gap:"4px 16px" }}>
                      {e.detalles.map((d,i)=>(
                        <div key={i} style={{ fontSize:"11px", padding:"3px 0", borderBottom:`0.5px solid ${borde}` }}>
                          <span style={{ color:sub }}>{d.label}: </span>
                          <span style={{ color:texto, fontWeight:"600" }}>{d.valor}</span>
                        </div>
                      ))}
                    </div>
                    {e.registradoPor && <p style={{ fontSize:"10px", color:sub, marginTop:"8px", marginBottom:0 }}>Registrado por: {e.registradoPor}</p>}
                    {e.esDestacado && (
                      <div style={{ marginTop:"8px", display:"inline-flex", alignItems:"center", gap:"4px", background:`${e.color}15`, border:`1px solid ${e.color}40`, borderRadius:"6px", padding:"3px 8px" }}>
                        <span style={{ fontSize:"9px", fontWeight:"700", color:e.color }}>◉ Código buscado</span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {/* ESTADO INICIAL */}
        {cadena.length===0 && !sinResultados && (
          <div style={{ textAlign:"center", padding:"4rem 2rem", background:cardBg, borderRadius:"16px", border:`1px solid ${borde}` }}>
            <p style={{ fontSize:"48px", marginBottom:"1rem" }}>🔗</p>
            <h3 style={{ fontSize:"16px", fontWeight:"700", color:texto, marginBottom:"8px" }}>Trazabilidad End-to-End</h3>
            <p style={{ fontSize:"13px", color:sub, maxWidth:"400px", margin:"0 auto" }}>
              Rastreá cualquier código del sistema y verás toda la cadena:<br/>
              <span style={{ fontFamily:"monospace", color:"#2A7FFF" }}>Proveedor → Material → Pallet → OT → NC → AC</span>
            </p>
            <div style={{ display:"flex", gap:"8px", justifyContent:"center", flexWrap:"wrap", marginTop:"1.5rem" }}>
              {[["IM-","Ingreso material","#2A7FFF"],["PAL-","Pallet/Stock","#7B5BF2"],["OP-","Orden de trabajo","#1C3FAA"],["NCI-","No conformidad","#e63946"]].map(([pre,lab,col])=>(
                <div key={pre} onClick={()=>onInputChange(pre)} style={{ padding:"8px 14px", background:`${col}12`, border:`1px solid ${col}30`, borderRadius:"10px", cursor:"pointer", textAlign:"center" }}>
                  <div style={{ fontFamily:"monospace", fontWeight:"700", color:col, fontSize:"12px" }}>{pre}…</div>
                  <div style={{ fontSize:"10px", color:sub, marginTop:"2px" }}>{lab}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
